import { TemplateRef } from '@angular/core';

export class PublishMetadataModel {
    label: string;
    value: any;
    customTemplate?: TemplateRef<any>;
    isUrl?: boolean = false;

    constructor(label?, value?, customTemplate?) {
        this.label = label;
        this.value = value;
        this.customTemplate = customTemplate;
    }
}
